import { render, staticRenderFns } from "./snackbar.vue?vue&type=template&id=53a9776f&scoped=true"
import script from "./snackbar.vue?vue&type=script&lang=ts"
export * from "./snackbar.vue?vue&type=script&lang=ts"
import style0 from "./snackbar.vue?vue&type=style&index=0&id=53a9776f&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a9776f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53a9776f')) {
      api.createRecord('53a9776f', component.options)
    } else {
      api.reload('53a9776f', component.options)
    }
    module.hot.accept("./snackbar.vue?vue&type=template&id=53a9776f&scoped=true", function () {
      api.rerender('53a9776f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/snackbar/snackbar.vue"
export default component.exports